import { Controller } from '@hotwired/stimulus';
import { toggleVisiblity } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'hideOnSuccess',
    'input',
    'showOnSuccess',
    'form',
    'toggle',
    'component',
    'showOnFailure',
    'submitButton',
  ];
  static classes = ['submitting'];

  showForm() {
    this.formTarget.classList.remove('hidden');
    this.toggleTarget.classList.add('hidden');
    this.componentTarget.setAttribute('aria-expanded', 'true');
  }

  handleSubmitting() {
    this.submitButtonTarget.classList.add(this.submittingClass);
    this.submitButtonTarget.innerText = 'wird verarbeitet';
  }

  handleSuccess() {
    let messages = event.detail[0].messages || [];
    this.showOnSuccessTarget.innerHTML = messages.join('\n<br/>');
    this.hideOnSuccessTargets.forEach((node) => toggleVisiblity(node, false));
    this.inputTargets.forEach((input) => (input.disabled = true));
    this.showOnSuccessTarget.classList.remove('hidden');
    this.showOnFailureTarget.classList.add('hidden');
  }

  handleFailure(event) {
    let messages = ['Wir konnten dich nicht anmelden.'];
    let errorMessages = event.detail[0].messages || [];
    messages = messages.concat(errorMessages.map((value) => `- ${value}`));
    this.showOnFailureTarget.innerHTML = messages.join('\n<br/>');
    this.showOnFailureTarget.classList.remove('hidden');
    this.submitButtonTarget.classList.remove(this.submittingClass);
    this.submitButtonTarget.innerText = 'Newsletter abonnieren';
  }
}
